import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { saveLoginIntent } from '../utils/loginIntent';

/**
 * Send the customer to the login screen with a clear message, remembering
 * this page (and what they were doing) so they come straight back to it —
 * see utils/loginIntent. Used when an action needs an account: a guest
 * starting it, or a save the server refused because the session is no longer
 * valid. In the latter case the stale session is cleared first, otherwise the
 * login screen would bounce a still "logged-in" user straight back.
 */
export function useLoginToContinue() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return useCallback(({ message, action = null, draft = null }) => {
    saveLoginIntent({ returnTo: location.pathname + location.search, action, draft });
    if (user) logout();
    toast.info(message);
    navigate('/login');
  }, [navigate, location.pathname, location.search, user, logout]);
}
